module.exports = __webpack_public_path__ + "static/media/20180523-LCS-022-20.9589b1ea.jpg";